import { render } from "./MessageGroupAddPage.vue?vue&type=template&id=0578ebc1"
import script from "./MessageGroupAddPage.vue?vue&type=script&lang=js"
export * from "./MessageGroupAddPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__